export default __webpack_public_path__ + "locales/ko-KR/InfoPanel.json?hash=5aff60a449536f0dc46bcbcd155ad870";